import { STICKY_NODE } from '@mbrtargeting/metatag-shared-modules';
import { CONFIG_RESOLVER } from '../../loader/token.js';
import { Registry } from '../../loader/di/registry.js';
import { EffectFunction } from './index.js';
import { ADHESION_UNIT_WATCHER } from '../token.js';
import { selectFeatureSettings, selectPositionSettings } from '../../loader/essentials/config-selector.js';
import { BehaviorSubject, isNonEmptyString } from '@mbrtargeting/metatag-utils';


export const STICKY_NODE2: EffectFunction = (adSlot) => {

    const { slotHull: targetNode, slotName } = adSlot;

    const config = Registry.lookup(CONFIG_RESOLVER);
    const { stickyStopUnitQuery, stickyStop } = config.get(selectFeatureSettings());

    //SecondarySkyscraper module might change positionSettings of "sky", to avoid colliding with "sky3" slot
    const stickyStopUnitQueries$ = new BehaviorSubject<string[]>([stickyStopUnitQuery]);
    config
        .get$(selectPositionSettings(slotName))
        .subscribe(positionSettings => {
            const { stickyStopQuery: slotStickyStopQuery } = positionSettings;

            //only present in positionSettings if changed by SecondarySkyscraper Module
            if (isNonEmptyString(slotStickyStopQuery)) stickyStopUnitQueries$.next([slotStickyStopQuery, stickyStopUnitQuery]);
        });

    return STICKY_NODE({
        targetNode,
        stickyStopUnitQueries$,
        stickyStop,
        adhesionUnitWatcher: Registry.lookup(ADHESION_UNIT_WATCHER),
    })
}
